$(function () {

    //お問い合わせ関連の対応
    $('#otoiawase-1').after('<span class="form-check-icon"></span>');
    $('#otoiawase-1').addClass('required');
    $('#otoiawase_checkbox input').addClass('validate[minCheckbox[1]]');
    $('#name').addClass('validate[required]');
    $('#kana').addClass('validate[required]');
    $('#mail').addClass('validate[required,custom[email]]');
    $('#mail').after('<span class="form-check-icon"></span>');
    $('#mail2').addClass('validate[required,equals[mail]] required');
    $('#mail2').after('<span class="form-check-icon"></span>');
    $('#inquiry').addClass('validate[required]');
    $('#privacy-1').after('<span class="form-check-icon"></span>');
    $('#privacy-1').addClass('validate[required]');

    //全体バリデーション&残りの入力項目カウント
    var $required = $('.required');
    var $disabled = $('.mw_wp_form_input .js-validation-disabled');
    $disabled.prop('disabled', 'disabled');

    var requiredNum = $required.length;
    var errorNum = requiredNum - $required.filter('.is-success').length;
    $('.items, .number').text(errorNum);

    $('#validation_form form').validationEngine('attach', {
        promptPosition: 'topLeft',
        addSuccessCssClassToField: 'is-success',
        addFailureCssClassToField: 'is-error',
        onFieldSuccess: function(field) {
            requiredCountDown();
        },
        onFieldFailure: function(field) {
            requiredCountDown();
        }
    });

    function requiredCountDown () {
        $('.number').text(requiredNum - $required.filter('.is-success').length);
        if (requiredNum === $required.filter('.is-success').length) {
            $disabled.prop('disabled', false);
        } else {
            $disabled.prop('disabled', 'disabled');
        }
    }

    //離脱の警告
    // if($('#validation_form')) {
    if($('#validation_form').length){
        $(window).on('beforeunload', function() {
            return 'フォームは未送信です。\n' +
                'このままページを移動するとフォームに入力したデータは保存されません。';
        });
        $('.js-no-withdrawal').on('click', function(e) {
            $(window).off('beforeunload');
        });
    }

    //セレクター　選択したら
    $('select').on('change',function(){
        if( this.value == '' ){
            this.style.color = '';
        } else {
            this.style.color = '#000';
        }
    });

    // カタ自動補完
    $.fn.autoKana('#name', '#kana', {
        katakana : false  //true：カタカナ、false：ひらがな（デフォルト）
    });

    //カタ自動補完時にバリデーションを実行
    $('#name').on('blur', function() {
        var kana = $('#kana');
        if(kana.val()) {
            kana.validationEngine('validate');
        }
    });

   //残りの入力項目カウント　スクロールしたら表示
    var remaining = $('.remaining');
    $(window).scroll(function () {
        if ($(this).scrollTop() > 300) {
            remaining.stop()
                .css({'visibility':'visible'})
                .animate({'opacity': '.9'}, 500, 'linear');
        } else {
            remaining.stop()
                .css({'visibility':'hidden'})
                .animate({'opacity': '0'}, 500, 'linear');
        }
    });


});
